import { useMemo } from 'react'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { getExtraProperty } from '@tribeplatform/gql-client/lib'
import { NetworkStatus } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const ONBOARDING_SKIPPED_EXTRA_PROPERTY_KEY =
  'internal:onboarding:skipped'

interface UseNavigateToAdministrationLinkProps {
  spaceId?: string
}

export const useNavigateToAdministrationLink = ({
  spaceId,
}: UseNavigateToAdministrationLinkProps = {}) => {
  const { data: network } = useNetwork()

  const navigateToAdministrationLink = useMemo(() => {
    const isSkipped = !!getExtraProperty(
      network?.extraProperties,
      ONBOARDING_SKIPPED_EXTRA_PROPERTY_KEY,
    )
    const isPublished = network.status === NetworkStatus.published

    if (isSkipped || isPublished) {
      return spaceId
        ? adminRoutes.site.spaces.root(spaceId)
        : adminRoutes.site.root
    }

    return adminRoutes.onboarding
  }, [network?.extraProperties, network.status, spaceId])

  return { navigateToAdministrationLink }
}
